export const enum EnumAtivarRevisarNFCE {
    DADOS_DA_EMPRESA = 1,
    NFCE = 2,
    CONCLUSAO = 3,
    NAOFISCAL = 4
}